<xux-drawer-container *ngIf="!predefinedReportFilters; else standaloneReport">
    <xux-drawer-sidebar></xux-drawer-sidebar>

    <xux-drawer-content>
        <xux-breadcrumb-navbar
            class="breadcrumb-nav"
            [isIframeMode$]="isIframeMode$"
            *ngIf="user$ | async"
            [appName]="'REPORTING' | translate"
        >
            {{ 'REPORTING' | translate }}
        </xux-breadcrumb-navbar>
        <div class="content-box">
            <dm-notifications></dm-notifications>
            <router-outlet></router-outlet>
        </div>
    </xux-drawer-content>
</xux-drawer-container>

<ng-template #standaloneReport>
    <xux-drawer-container>
        <xux-drawer-content>
            <div class="content-box">
                <dm-notifications></dm-notifications>
                <router-outlet></router-outlet>
            </div>
        </xux-drawer-content>
    </xux-drawer-container>
</ng-template>

<dm-generic-modal></dm-generic-modal>
<dm-dropdown-menu></dm-dropdown-menu>

<dm-company-selection
    [currentCompanyId]="currentCompanyId$ | async"
    [companiesList]="companies$ | async"
    [showCompanySelector]="showCompanySelector$ | async"
    (selectedItem)="selectCompany($event)"
></dm-company-selection>
